import React from 'react';
import PropTypes from 'prop-types';
import { Label } from 'semantic-ui-react';

export const APPROVAL_REQUIREMENT_LABELS = {
  HIGHER_DISCOUNT: 'Higher Discount',
  BONUS_SUBSCRIPTION: 'Bonus Subscription',
};

const ApprovalRequirements = ({ requirements }) => {
  if (!requirements || requirements.length === 0) {
    return <Label size="small">None</Label>;
  }
  return requirements.map(req => (
    <Label
      key={req}
      color="orange"
      size="small"
      style={{ marginBottom: '0.2em' }}
    >
      {APPROVAL_REQUIREMENT_LABELS[req] || req}
    </Label>
  ));
};

ApprovalRequirements.propTypes = {
  requirements: PropTypes.arrayOf(PropTypes.string),
};

ApprovalRequirements.defaultProps = {
  requirements: [],
};

export default ApprovalRequirements;
